import React, { Component } from "react";
import NavDE from "../Symbols/NavDE";
import FooterDE from "../Symbols/FooterDE";
import "../../stylesheets/Kontakt.css";
import { Helmet } from "react-helmet-async";
import NewsArchiveCard from "../elements/NewsArchiveCard";
import { newsletters, mergeNewsletters } from "../../data/newsletters";

class News_Overview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      news: newsletters,
    };
  }

  componentDidMount() {
    this.fetchNews();
  }

  fetchNews = async () => {
    let offset = "";
    let count = 10;
    let records = [];
    let records_filtered = []
    for (let i = 0; i < count; i++) {
      const response = await fetch(
        `https://api.airtable.com/v0/appTEn3LDZ56nauxj/tbleN5eldbuGJNbYB?offset=${offset}`, { headers: { 'Authorization': 'Bearer patSxqK40aDpd0iY6.beedbae8aef0d8ef37eaa0268af4654eb5113643efb69777ef67367c2031ee09' } }
      );
      const data = await response.json();
      records = records.concat(data.records);
      if (data.offset) {
        offset = data.offset;
      } else {
        break;
      }
    }

    records.forEach((news, key) => {
      if (Object.keys(news.fields).length !== 0 && "Titel_DE" in news.fields && "Link_DE" in news.fields && "Published" in news.fields) {
        records_filtered.push(news)
      }
    });

    this.setState({
      news: mergeNewsletters(records_filtered, "de"),
    });
  };

  render() {
    return (
      <div className="content">
        <Helmet>
          <title>Pancon - News</title>
          <meta
            name="description"
            content="Abonnieren Sie den Pancon Newsletter und bleiben Sie stets informiert über
innovative Technologien, Produktneuheiten und Branchentrends. Exklusives Wissen
für jeden der auf der Suche nach einer Verbindungstechnologien ist – direkt in Ihrem
Posteingang!"
          />
          <meta property="og:title" content="Pancon - News" />
          <meta
            property="og:description"
            content="Abonnieren Sie den Pancon Newsletter und bleiben Sie stets informiert über
innovative Technologien, Produktneuheiten und Branchentrends. Exklusives Wissen
für jeden der auf der Suche nach einer Verbindungstechnologien ist – direkt in Ihrem
Posteingang!"
          />
          <link
            rel="alternate"
            href="https://www.pancon.de/de/news"
            hrefLang="de"
          ></link>
          <link
            rel="alternate"
            href="https://www.pancon.de/en/news"
            hrefLang="en"
          ></link>
        </Helmet>
        <NavDE />
        <div className="section flex first intro center-h less-bot">
          <div className="medium flex">
            <div className="heading1-cont flex center-v">
              <div className="heading-deco m-right-3"></div>
              <h1>News</h1>
            </div>
            <div className="flex news-contt">
              {this.state.news.map((news, i) => (
                <NewsArchiveCard key={i} lang="de" news={news} />
              ))}
            </div>
          </div>
        </div>
        <FooterDE />
      </div>
    );
  }
}

export default News_Overview;
